import { GoogleLogin } from "@react-oauth/google";
import { t } from "../i18n";

export default function LoginMethodModal({
  lang,
  onClose,
  onSelectEmail,
  onGoogleSuccess,
  title,
  description,
}) {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 overflow-hidden">
        {/* Header */}
        <div className="px-8 pt-8 pb-2">
          <h2 className="text-2xl font-bold text-gray-900 text-center">
            {title || t(lang, "signIn")}
          </h2>
          {description && (
            <p className="mt-2 text-sm text-gray-500 text-center leading-relaxed">
              {description}
            </p>
          )}
        </div>

        {/* Options */}
        <div className="px-8 pb-8 flex flex-col gap-5">
          {/* Email Login */}
          <button
            onClick={onSelectEmail}
            className="w-full flex items-center gap-4 px-5 py-4 rounded-xl border border-gray-200 hover:border-indigo-300 hover:bg-indigo-50/50 transition group text-left"
          >
            <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center flex-shrink-0 group-hover:bg-indigo-200 transition">
              <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <div className="font-medium text-gray-900 group-hover:text-indigo-700 transition">
                {t(lang, "emailLogin")}
              </div>
              <div className="text-sm text-gray-500">
                {t(lang, "emailLoginHint")}
              </div>
            </div>
          </button>

          {/* Google Login */}
          <div className="flex flex-col items-center gap-2">
            <GoogleLogin
              onSuccess={onGoogleSuccess}
              onError={() => console.error("Google login failed")}
              size="large"
              width={320}
              theme="outline"
              text="continue_with"
            />
            <span className="text-xs text-gray-400">
              {t(lang, "googleLoginHint")}
            </span>
          </div>

          {/* Cancel */}
          <button
            onClick={onClose}
            className="w-full py-3 text-sm text-gray-500 hover:text-gray-700 transition text-center"
          >
            {t(lang, "cancel")}
          </button>
        </div>
      </div>
    </div>
  );
}
